module.exports = __webpack_public_path__ + "static/img/manual_zh_36.1fa4192.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_36.png
// module id = HKxm
// module chunks = 4